import React from 'react';
import PropTypes from 'prop-types';

import Color from '../assets/colore.svg?react';
import Superscript from '../assets/esponente.svg?react';
import PlusMinus from '../assets/piu-meno.svg?react';
import Parenthesis from '../assets/tonda.svg?react';
import SquareBracket from '../assets/quadra.svg?react';
import CurlyBracket from '../assets/graffa.svg?react';
import Nroot from '../assets/radice-complessa.svg?react';
import SquareRoot from '../assets/radice.svg?react';
import Fraction from '../assets/frazione.svg?react';
import GreatherThan from '../assets/maggiore.svg?react';
import LessThan from '../assets/minore.svg?react';
import LessEqual from '../assets/minore-uguale.svg?react';
import GreatherEqual from '../assets/maggiore-uguale.svg?react';
import LCurlyColumn from '../assets/sistema.svg?react';
import NotEqual from '../assets/diverso.svg?react';
import EncloseTop from '../assets/periodico.svg?react';
import Abs from '../assets/valore-assoluto.svg?react';
import Matrix from '../assets/matrice.svg?react';

import Delete from '../assets/delete.svg?react';
import Edit from '../assets/edit.svg?react';
import Plus from '../assets/plus.svg?react';
import Minus from '../assets/minus.svg?react';

const IconItem = (props) => {
    switch (props.name) {
        case 'color':
            return <Color {...props} />;
        case 'superScript':
            return <Superscript {...props} />;
        case 'plusMinus':
            return <PlusMinus {...props} />;
        case 'parenthesis':
            return <Parenthesis {...props} />;
        case 'squareBracket':
            return <SquareBracket {...props} />;
        case 'curlyBracket':
            return <CurlyBracket {...props} />;
        case 'squareRoot':
            return <SquareRoot {...props} />;
        case 'nRoot':
            return <Nroot {...props} />;
        case 'fraction':
            return <Fraction {...props} />;
        case 'greatherThan':
            return <GreatherThan {...props} />;
        case 'lessThan':
            return <LessThan {...props} />;
        case 'lessEqual':
            return <LessEqual {...props} />;
        case 'greatherEqual':
            return <GreatherEqual {...props} />;
        case 'encloseTop':
            return <EncloseTop {...props} />;
        case 'lCurlyColumn':
            return <LCurlyColumn {...props} />;
        case 'notEqual':
            return <NotEqual {...props} />;
        case 'absolute':
            return <Abs {...props} />;
        case 'matrix':
            return <Matrix {...props} />;

        case 'delete':
            return <Delete {...props} />;
        case 'edit':
            return <Edit {...props} />;
        case 'plus':
            return <Plus {...props} />;
        case 'minus':
            return <Minus {...props} />;

        default:
            return <Edit {...props} />;
    }
};

IconItem.propTypes = {
    name: PropTypes.string,
};

export default IconItem;
